var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90625 6.88176C4.90625 4.53081 6.81206 2.625 9.16301 2.625C11.514 2.625 13.4198 4.53081 13.4198 6.88176C13.4198 9.2327 11.514 11.1385 9.16301 11.1385C6.81206 11.1385 4.90625 9.2327 4.90625 6.88176Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9648 3.05849C13.9468 4.03505 14.5547 5.38741 14.5547 6.88176C14.5547 8.3761 13.9468 9.72845 12.9648 10.705C13.5301 10.9827 14.1662 11.1385 14.8385 11.1385C17.1895 11.1385 19.0953 9.2327 19.0953 6.88176C19.0953 4.53081 17.1895 2.625 14.8385 2.625C14.1662 2.625 13.5301 2.78089 12.9648 3.05849Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 17.098C1.5 14.747 3.40581 12.8412 5.75676 12.8412H12.5676C14.9185 12.8412 16.8243 14.747 16.8243 17.098C16.8243 19.449 14.9185 21.3547 12.5676 21.3547H5.75676C3.40581 21.3547 1.5 19.449 1.5 17.098Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9603 17.0979C17.9603 18.2613 17.5918 19.3386 16.9652 20.2196H18.244C20.595 20.2196 22.5008 18.3138 22.5008 15.9628C22.5008 13.6118 20.595 11.7061 18.244 11.7061H12.5684C15.5463 11.7061 17.9603 14.12 17.9603 17.0979Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/UserManagement.09be2bf70d25b9f6b86ca50d69a88177.svg";
export { ForwardRef as ReactComponent };